<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import store from './store'
export default {
  store,
  name: 'app'
}
</script>

<style lang='scss'>
html,body{
  padding: 0;
  margin: 0;
  border: 0;
  width: 100%;
  height: auto;
}
#app {
  font-family: 'Helvetica Neue';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1280px;
  width: 100%;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue